var apci = (function(AP, $, _){
    "use strict";
    //Will update the menu"s selected/active links based on the windows current
    //location and the link href values.
    function updateAPNavigation() {
        var currentUrl = window.location.href;
        var allLinks = $(".sidebar-nav li>a");
        $(".navbar-nav>li:has(ul.collapse)>a:not(\".navbar-collapsible-header.sm\")").addClass("ap-nav-parent");
        $(".navbar-nav>li.selected").parents("li").removeClass("active");
        $(".navbar-nav>li.selected").parents("ul.collapse").removeClass("in");
        $(".navbar-nav>li.selected").removeClass("selected");

        var filteredLinks = _.filter(allLinks, function(e){
            return (currentUrl.indexOf($(e).attr("href")) !== -1);
        });
        var elm = _.reduce(filteredLinks, function(a, b){
            return $(a).attr("href").length > $(b).attr("href").length ? a : b;
        });

        var closestLi = $(elm).closest("li");
        //set current list item as selected
        closestLi.addClass("selected");
        //set any parent list items as active
        closestLi.parents("li").addClass("active");
        //set any parent uncollapse any lists that are parents
        var closestUl = closestLi.parents("ul.collapse");
        closestUl.addClass("in");
        closestUl.siblings("a.navbar-collapsible-header").addClass("in");
    }

    //Adds collapsible menu functionality to the navigation menu.
    function addAPCollapsibleMenu(){
        $(".navbar-nav>li:has(ul.collapse)").each(function _addCollapsibleHeaderClass(){
            var $this = $(this);
            var $children = $this.children("a");
            //DOM will be different depending on how the developer decided to
            //layout the navigation menu.  If the parent is text and not a link
            //the collapsible menu header will be 100% otherwise the
            //collapsible menu header will be 80%, leaving 20% for a new link
            //element to collapse the children.
            if($children.length){
                //check if the first child is open, if so make sure the default
                //for the arrow is open.
                $("<a class=\"navbar-collapsible-header sm" + ($this.has("ul.in").length ? " in" : "") + "\"></a>")
                    .prependTo($this)
                    .on("click", function _sideBarHeaderToggleSM() {
                        var $collapsibleMenuLink = $(this);
                        var $sibling = $collapsibleMenuLink.siblings("ul.collapse");
                        //For some reason on IE 9 using collapse("toggle") does not function
                        //on the first click.
                        if ($sibling.hasClass("in")) {
                            $sibling.collapse("hide");
                        }
                        else {
                            $sibling.collapse("show");
                        }
                        $collapsibleMenuLink.toggleClass("in");
                    })
                    .siblings("a")
                    .addClass("navbar-collapsible-header-sb");
            }
            else{
                var node = $this
                    .contents()
                    .filter(function(){
                        return this.nodeType === 3;
                    })[0];
                var text = node.nodeValue;
                $("<a class=\"navbar-collapsible-header lg" + ($this.has("ul.in").length ? " in" : "") + "\">" + text + "</a>")
                    .prependTo($this)
                    .on("click", function _sideBarHeaderToggleLG() {
                        var $collapsibleMenuLink = $(this);
                        var $sibling = $collapsibleMenuLink.siblings("ul.collapse");
                        //For some reason on IE 9 using collapse("toggle") does not function
                        //on the first click.
                        if ($sibling.hasClass("in")) {
                            $sibling.collapse("hide");
                        }
                        else {
                            $sibling.collapse("show");
                        }
                        $collapsibleMenuLink.toggleClass("in");
                    });
                node.nodeValue = "";
            }
        });
    }

    $(function _apciNavigationInit() {
        //Trigger on window on load...
        $(".toggle-menu").jPushMenu({closeOnClickLink: false}); //mobile push menu
        try{
            addAPCollapsibleMenu();
        }
        catch(ex){
            //This should not be happening
            console.error("apci collasible menu error: " + ex.message + "\n stacktrace: " + ex.stack);
        }
        try {
            //update the navigation menu on the load...
            updateAPNavigation();
            //add a handler to the window's hashchange...
            $(window).on("hashchange", function updateAPNavigationHashChange() {
                updateAPNavigation();
            });
        }
        catch(ex){
            //This should not be happening
            console.error("apci menu navigation error: " + ex.message + "\n stacktrace: " + ex.stack);
        }
    });
    AP.initAPCINavMenu = function(){
        addAPCollapsibleMenu();
        updateAPNavigation();
    };

    return AP;
})(apci || {}, jQuery, _);
